import React, { useState } from 'react';

import {
  ClickAwayListener,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

import { makeStyles } from 'tss-react/mui';

export interface IErrorTooltipIconProps {
  helperText?: any;
}

const useStyles = makeStyles<Theme>()((theme) => ({
  tooltip: {
    maxWidth: '200px',
    minWidth: '200px',
    whiteSpace: 'normal',
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    marginRight: '0 !important',
  },
  tooltipText: {
    width: '100%',
    maxWidth: '200px',
    minWidth: '200px',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
}));

const ErrorTooltipIcon: React.FC<IErrorTooltipIconProps> = ({ helperText }) => {
  const [open, setOpen] = useState<boolean>(false);
  const theme = useTheme();

  const { classes } = useStyles(theme);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          placement="left"
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          classes={{ tooltip: classes.tooltip }}
          title={
            <Typography variant="text-sm" className={classes.tooltipText}>
              {helperText}
            </Typography>
          }>
          <IconButton size="small" onClick={() => handleTooltipOpen()}>
            <PriorityHighIcon style={{ color: theme.palette.error.main }} />
          </IconButton>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default ErrorTooltipIcon;
